export default __webpack_public_path__ + "media/suspicious_login_attempt/device-2904b32b.png";